var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((2),function(i){return _c('div',{staticClass:"block-border palette-color-text"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }